/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".closeButton[_ngcontent-%COMP%]{color:#707070;font-weight:bolder;font-size:1rem;cursor:pointer}.headerText[_ngcontent-%COMP%]{font-size:.875rem;color:#696969;font-weight:700}.bodyText[_ngcontent-%COMP%]{font-size:.875rem;color:#676767;line-height:1rem}.inProcessFont[_ngcontent-%COMP%]{color:#00789e}.inProcessOption[_ngcontent-%COMP%]{cursor:pointer}.inProcessOption[_ngcontent-%COMP%]:hover{background-color:#f3fafd}"];
export { styles as styles };
